'use client';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import DynamicLogo from '@components/DynamicLogo';
import CommonContainer from '@components/CommonContainer';
import WorldAldarNavigation from '@components/WorldAldarNavigation';

import cn from './style.module.scss';

export default function OgamiAboutus(props: MarketingPageComponentProps) {
  const aboutusSection = props?.locale?.section?.find(
    (section: any) => section.type === 'aboutus' && section.enabled
  );
  if (!aboutusSection) return null;
  return (
    <Stack component="section" className={cn.ogamiAboutusWrapper}>
      <Box className={cn.ogamiAboutusInner}>
        <CommonContainer
          paddingInline={{ xs: '32px', sm: '32px', md: '24px' }}
          maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.ogamiAboutusBlock}>
            <Box className={cn.ogamiAboutusWorld}>
              <WorldAldarNavigation
                data={aboutusSection?.ogamiAboutWorldOfAldar}
                classNames={{
                  wrapper: cn.ogamiAboutusWorldWrapper,
                  data: cn.ogamiAboutusWorldData,
                  button: cn.ogamiAboutusWorldButton,
                }}
              />
            </Box>
            <Box className={cn.ogamiAboutusData}>
              <Box className={cn.ogamiAboutusHeader}>
                <Box className={cn.ogamiAboutusHeader__title}>
                  <ParallaxText
                    variant="h2"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(aboutusSection?.ogamiAboutusHeading)}
                  </ParallaxText>
                </Box>
                <Box className={cn.ogamiAboutusHeader__logo}>
                  <DynamicLogo
                    logoImage={aboutusSection?.ogamiAboutusLogo}
                    alt={'Ogami Logo'}
                  />
                </Box>
              </Box>
              <Box className={cn.ogamiAboutusContent}>
                {aboutusSection?.ogamiAboutusContent?.map(
                  (content: string, index: number) => (
                    <ParallaxText
                      key={index}
                      variant="p"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(content)}
                    </ParallaxText>
                  )
                )}
              </Box>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
